<template>
  <!-- <chartjs-line-card :chartData="chartData" :chartOptions="chartOptions">
    <template slot="header">
      <div style="display: flex;">
        <h4 class="card-title dashboard-cards-header">ROI By Time</h4>
        <div
          style="margin-left:5px;margin-top: auto;margin-bottom: auto;"
          v-tooltip.top-end="toolTipInfo"
        >
          <img src="static/img/graphInfo.svg" class />
        </div>
        <div class="hlpicon" v-tooltip.top-end="toolTipInfo" style="display:none">
          <i class="fa fa-question-circle fa-lg" aria-hidden="true"></i>
        </div>
      </div>
    </template>
  </chartjs-line-card> -->
  <div>
    <div class="card-header">
      <div style="display: flex">
        <h4 class="card-title dashboard-cards-header">ROI By Time</h4>
        <div
          style="margin-left: 5px; margin-top: auto; margin-bottom: auto"
          v-tooltip.top-end="toolTipInfo"
        >
          <img src="static/img/graphInfo.svg" class />
        </div>
        <div
          class="hlpicon"
          v-tooltip.top-end="toolTipInfo"
          style="display: none"
        >
          <i class="fa fa-question-circle fa-lg" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="card-box">
        <chartjs-line
          :chartData="chartData"
          :chartOptions="chartOptions"
          :style="lineChartStyle"
        >
        </chartjs-line>
      </div>
    </div>
  </div>
</template>
<script>
import { vals, formatCurrency } from "../../../util";
import { Select, Option } from "element-ui";
import { ChartjsLineCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
import ChartjsLine from "../../Chartjs/ChartjsLine";

const MONTH = "month";
const MONTH_FORMAT = "MMM YYYY";
const YEAR = "year";
const YEAR_FORMAT = "YYYY";
const QUARTER = "quarter";
const QUARTER_FORMAT = "[Q]Q YYYY";

export default {
  name: "line-roi-time-chart-card",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsLineCard,
    ChartjsLine,
  },
  computed: {
    ...mapGetters("charts", [
      "portfolioROIByMonth",
      "portfolioROIByYear",
      "dashboardPortfolioROIByMonth",
      "dashboardPortfolioROIByYear",
      "category",
      "subCategory",
    ]),
    ...mapGetters("user", ["currency"]),
    categoryOptions() {
      // get all of the non-numerical values
      let retval = [];
      retval = _.map(vals.PORTFOLIO.GRAPH_OPTIONS, (v) => {
        let label = _.has(vals.HEADER_MAP, v)
          ? vals.HEADER_MAP[v]
          : _.startCase(v);
        return { label, value: v };
      });
      return _.without(retval, undefined, null);
    },
    chartUnit() {
      const self = this;
      // temp solution: do quarters
      // setup our time tick steps correctly based on data points
      switch (self.dateUnit) {
        case MONTH:
          // return month format
          return {
            tooltipFormat: MONTH_FORMAT,
            round: MONTH,
            unit: MONTH,
            displayFormats: {
              month: MONTH_FORMAT,
            },
          };
        case YEAR:
          // return year format
          return {
            tooltipFormat: YEAR_FORMAT,
            round: YEAR,
            unit: YEAR,
            displayFormats: {
              year: YEAR_FORMAT,
            },
          };
        case QUARTER:
          return {
            tooltipFormat: MONTH_FORMAT,
            round: MONTH,
            unit: MONTH,
            displayFormats: {
              quarter: QUARTER_FORMAT,
            },
          };
        default:
          return {};
      }
    },
    chartData() {
      const self = this;
      //let portfolioInfo = self.portfolioROIByMonth();
      let portfolioInfo = self.dashboardPortfolioROIByMonth();
      self.dateUnit = MONTH;
      // get unique of both value_t and cost_t
      // if it is too large use years instead
      if (_.union(portfolioInfo.value_t, portfolioInfo.cost_t).length > 24) {
        // do year instead
        //portfolioInfo = self.portfolioROIByYear();
        portfolioInfo = self.dashboardPortfolioROIByYear();
        self.dateUnit = YEAR;
      }
      let labels = portfolioInfo.time;
      let valueData = _.zipWith(
        portfolioInfo.value_t,
        portfolioInfo.value,
        function (x, y) {
          return { x, y };
        }
      );
      let costData = _.zipWith(
        portfolioInfo.cost_t,
        portfolioInfo.cost,
        function (x, y) {
          return { x, y };
        }
      );
      self.dataLength = Math.max(valueData.length, costData.length);
      let data = {
        datasets: [
          {
            label: "Cost",
            data: costData,
            backgroundColor: "#006BFD",
            borderColor: "#006BFD",
            fill: false,
          },
          {
            label: "Value",
            data: valueData,
            backgroundColor: "#2EB7FF",
            borderColor: "#2EB7FF",
            fill: false,
          },
        ],
      };
      return data;
    },
    chartOptions() {
      const self = this;
      return {
        maintainAspectRatio: this.aspectRatio,
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].label || "") +
                ": " +
                formatCurrency(
                  data.datasets[toolTipItem.datasetIndex].data[
                    toolTipItem.index
                  ].y || 0,
                  self.currency.ref,
                  0,
                  true
                )
              );
            },
          },
        },
        legend: {
          position: "top",
          align: "end",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
          },
        },
        scales: {
          xAxes: [
            {
              type: "time",
              distribution: "series",
              bounds: "ticks",
              time: self.chartUnit,
              ticks: {
                source: "data",
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return formatCurrency(value, self.currency.ref, 0);
                },
              },
            },
          ],
        },
      };
    },
    toolTipInfo() {
      // right now just return the default (only) string
      return "Displays the values on the left graph of investments in your portfolio plotted against the invested on date";
    },
    lineChartStyle() {
      return {
        position: "relative"
      };
    }
  },
  data() {
    return {
      // category: {
      //   selected: "initial",
      //   title: "Time"
      // },
      dataLength: 0,
      // dateUnit: MONTH
    };
  },
  props: {
    aspectRatio: {
      type: Boolean,
      default() {
        return false;
      },
    },
    toolTip: {
      type: String,
      default() {
        return `This chart shows the ROI of your portfolio over time.`;
      },
    },
  },
  mounted() {
    const self = this;
  },
  watch: {
    category: {
      handler(newData) {
        // updated portfolio, run update
        if (newData.length > 0) this.chartData;
      },
    },
    subCategory: {
      handler(newData) {
        // updated portfolio, run update
        if (newData.length > 0) this.chartData;
      },
    },
  },
};
</script>